import { render } from "./Header.vue?vue&type=template&id=3a15ee64"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
script.render = render

export default script